import $ from "jquery";
import _debounce from "lodash/debounce";
import _each from "lodash/each";
import "slick-carousel";

// get our main.js incorporated for tracking and stuff
import initMain from "../main";
import { actualLineHeight } from "../util";

// overload window.wsjs to incorporate candidate.initMain
// so that the call in the new template emulates our default call
window.wsjs = { ...window.wsjs, candidate: { initMain } };

window.jQuery = $;
window.$ = $;

// sessionStorage should be *relatively* safe to use
const { sessionStorage } = window; //eslint-disable-line

// SLICK CAROUSEL INIT
$(".carousel-inner").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    dots: true,
    speed: 600,
    cssEase: "ease",
    // adaptiveHeight: true,
});

// EXPAND / COLLAPSE FOR MOBILE JOB CARDS
function jobCardToggle(e) {
    const card = e.target.closest(".job-card");
    if (card.classList.contains("collapsed")) {
        card.classList.remove("collapsed");
        card.classList.add("expanded");
    } else {
        card.classList.remove("expanded");
        card.classList.add("collapsed");
    }
}

$(document).on("click", ".job-card-expand-collapse-button", (e) => {
    jobCardToggle(e);
});

// Addreses Modal Form
const modal = document.getElementById("address-modal");
const close = document.querySelector("#close-modal");
const addressForm = document.getElementById("address-form");
const clearButton = document.getElementById("clear-address");
const addressInput = document.getElementById("modal-autocomplete");
const errorMessage = document.getElementById("address-error-message");
const calcButton = document.getElementById("calculate");

// cross browser body scroll setting
const html = document.getElementsByTagName("html")[0];
function stopBodyScroll() {
    html.classList.add("modal-open");
}

function allowBodyScroll() {
    html.classList.remove("modal-open");
}

// open Modal, if job card save id to keep expanded on page reload
function openModal(e) {
    stopBodyScroll();
    modal.style.display = "flex";
    if (e.target.classList.contains("job-card-trigger")) {
        const parentCard = e.target.closest(".job-card");
        const cardID = parentCard.id;
        sessionStorage.setItem("cardClick", cardID);

        const distanceCardTop = parentCard.getBoundingClientRect().top;
        sessionStorage.setItem("scrollPosition", `${distanceCardTop}`);
        sessionStorage.getItem("scrollPosition");
    }
}

function closeModal() {
    addressInput.value = "";
    modal.style.display = "none";
    allowBodyScroll();
    if (addressForm.classList.contains("has-error")) {
        addressForm.classList.remove("has-error");
    }
    window.autocomplete.set("place", null);
}

$(document).on("click", ".modal-trigger", (e) => {
    openModal(e);
});

// Close modal
close.onclick = () => {
    closeModal();
    sessionStorage.setItem("scrollPosition", "0");
    sessionStorage.setItem("cardClick", "");
};

// Clear Address  in modal
clearButton.addEventListener("click", (e) => {
    e.preventDefault();
    addressInput.value = "";
    e.target.setAttribute("disabled", "disabled");
});

// Handle Modal Address Input
function submitAddress(e) {
    e.preventDefault();
    const { value } = addressInput;
    if (value === "") {
        handleNoAddress();
    } else {
        processAddressInput(addressInput);
    }
}

// Error Message - No address
function handleNoAddress() {
    addressForm.classList.add("has-error");
    errorMessage.innerText = "Please enter an address";
}

// Error Message - Invalid address
function handleInvalidAddress() {
    addressForm.classList.add("has-error");
    errorMessage.innerText = "Unable to estimate commute from this address";
}

// Address Input, remove error state on input change, hande clear address state
addressInput.addEventListener("input", (e) => {
    addressForm.classList.remove("has-error");
    errorMessage.innerText = "";
    if (e.target.value !== "") {
        if (clearButton.hasAttribute("disabled")) {
            clearButton.removeAttribute("disabled");
        }
    } else if (!clearButton.hasAttribute("disabled")) {
        clearButton.setAttribute("disabled", "disabled");
    }
});

/* Process address

This is used by address modal input
Autocomplete is saved to window.autocomplete, used here
args:
    - input, the input element
*/
function processAddressInput(input) {
    calcButton.innerHTML = "Calculating";
    calcButton.classList.add("loading");

    const place = window.autocomplete.getPlace();
    if (!place || !place.geometry) {
        handleInvalidAddress();
    } else {
        const data = {
            address: input.value,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
        };

        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };

        // WS inserts their work
        fetch("/api/hire/v1/commute/", options).then((response) => {
            response.json().then(({ geohash }) => {
                // include geohash in data?
                if (!geohash) {
                    // this is an error condition
                } else {
                    // go ahead and set location cookie
                    data.geohash = geohash;
                    // Form Geolocation Cookie Object
                    const geoValues = {};
                    _each(place.address_components, (item) => {
                        const type = item.types;
                        if (type.includes("locality")) {
                            geoValues.locality = item.long_name;
                        } else if (!type.includes("locality") && type.includes("subocality")) {
                            geoValues.locality = item.long_name;
                        }
                        if (type.includes("administrative_area_level_1")) {
                            geoValues.state = item.short_name;
                        }
                    });

                    const geoData = `${geoValues.locality}, ${geoValues.state}`;
                    data.city = geoData;

                    // document.cookie = `geolocation=${JSON.stringify(geoData)};expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
                    document.cookie = `geolocation=${encodeURIComponent(
                        JSON.stringify(data),
                    )};path=/`;
                    window.autocomplete.set("place", null);

                    setTimeout(() => {
                        closeModal();
                        calcButton.innerHTML = "Calculate";
                        calcButton.classList.remove("loading");
                        window.location.reload();
                    }, 2000);
                }
            });
        });
    }
}
addressForm.addEventListener("submit", submitAddress);

// clamp all '.clamp' elements
const setClamps = (defaultHeight = 200) => {
    _each(document.querySelectorAll(".clamp"), (clamp) => {
        const maxHeight = parseInt(clamp.dataset.maxHeight, 10) || defaultHeight;
        const content = clamp.querySelector("p"); // first direct p child
        if (content && !clamp.classList.contains("touched")) {
            const { height } = content.getBoundingClientRect(); // full height
            if (height > maxHeight) {
                // find number of lines to show within this height
                const lineHeight = actualLineHeight(content);
                const showLines = Math.floor(maxHeight / lineHeight);
                const showHeight = showLines * lineHeight;
                // use css to clamp to that number, showing an ellipsis for webkit/firefox
                content.style.webkitLineClamp = showLines;
                content.style.lineClamp = showLines;
                // enforce clamp styles / height for all browsers
                clamp.classList.add("clamped");
                content.style.height = `${showHeight}px`;
                // create and show 'show more' link
                const link = document.createElement("a");
                link.href = "#";
                link.dataset.open = "false";
                link.addEventListener("click", (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    clamp.classList.add("touched");
                    if (clamp.classList.contains("clamped")) {
                        clamp.classList.remove("clamped");
                        content.style.height = `auto`;
                        link.innerText = "show less";
                    } else {
                        clamp.classList.add("clamped");
                        content.style.height = `${showHeight}px`;
                        link.innerText = "show more";
                    }
                });
                link.appendChild(document.createTextNode("show more"));
                clamp.appendChild(link);
            }
        }
        clamp.classList.remove("pre-clamp");
    });
};

//  DOM LISTENERS

// If Address Submitted via card, scroll to card on reload and expand if mobile
function handleReloadCardClicked() {
    const cardID = sessionStorage.getItem("cardClick");
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (cardID && cardID !== "") {
        const card = document.getElementById(cardID);

        setTimeout(() => {
            // scroll back to the card whose update address modal initialized the page reload
            const scroll = parseInt(sessionStorage.getItem("scrollPosition"), 10);
            const y = card.offsetTop - scroll;
            if (scroll && scroll > 0) {
                window.scrollTo(0, y);
            }

            // expand the card as it was expanded when selected on mobile
            if (isMobile) {
                card.classList.remove("collapsed");
                card.classList.add("expanded");
            }
            sessionStorage.setItem("cardClick", "");
            sessionStorage.setItem("scrollPosition", "0");
        }, 100);
    } else {
        sessionStorage.setItem("cardClick", "");
        sessionStorage.setItem("scrollPosition", "0");
    }
}

// WINDOW LISTENERS

// Window click modal/filters close
window.addEventListener("click", (e) => {
    if (e.target === modal) {
        closeModal();
        window.autocomplete.set("place", null);
    }
});

window.addEventListener("load", () => {
    handleReloadCardClicked();
    setClamps();
});

window.addEventListener("resize", _debounce(setClamps, 150));

export default {};
